<template>
  <div class="inner_content">
    <div class="header">
      <div class="box flex" style="align-items=center">
        <el-button
          type="primary"
          size="small"
          @click="$router.push('seting?type=' + presentId)"
          >添加洗车项目</el-button
        >
      </div>
    </div>
    <div class="bottom">
      <el-table
        :data="listData"
        size="small"
        :header-cell-style="setHeader"
        height="100%"
      >
        <el-table-column label="洗车项目名称" prop="name"></el-table-column>
        <!-- <el-table-column label="会员等级" prop="level"></el-table-column> -->
        <el-table-column label="所需积分" prop="score"></el-table-column>
        <el-table-column label="是否需要验证" prop="verify"></el-table-column>
        <el-table-column label="是否显示" prop="show"></el-table-column>
        <el-table-column width="465px" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              slot="reference"
              @click="editors(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              type="text"
              slot="reference"
              @click="option(scope.row.id)"
              >删除</el-button
            >
            <el-button type="text" @click="downloadQrcode(scope.row.id, 2)"
              >微信小程序码</el-button
            >
            <el-button type="text" @click="downloadQrcode(scope.row.id, 3)"
              >支付宝小程序码</el-button
            >
            <el-button type="text" @click="downloadQrcode(scope.row.id, 1)"
              >普通码</el-button
            >
            <el-button type="text" slot="reference" @click="downloadImg"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="total_num"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { indexWash, delWash } from "@/api/carWash";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"])
  },
  inject: ["reload"],
  data() {
    return {
      presentId: "",
      page: "1",
      total_num: 0,
      listData: [],
      dialogFormVisible: false,
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.presentId = this.$route.query.type;
    this.getLists();
  },
  methods: {
    downloadQrcode(id, type = 1) {
      console.log("id", id);

      let params = {
        service_id: id,
        token: this.token,
        app_id: this.app_id
      };
      var param =
        "?token=" + this.token + "&app_id=" + this.app_id + "&service_id=" + id;
      if (type == 1) {
        //关注收款码
        var url1 =
          "https://www.58zltc.com/service/agent.index/h5_downLoad" + param;
        if (this.status == "test") {
          url1 =
            "https://cs.58zltc.com/service/agent.index/h5_downLoad" + param;
        }
        window.location.href = url1;
      } else if (type == 2) {
        //微信码
        var url1 =
          "https://www.58zltc.com/service/agent.index/wxapp_downLoad" + param;
        if (this.status == "test") {
          url1 =
            "https://cs.58zltc.com/service/agent.index/wxapp_downLoad" + param;
        }
        window.location.href = url1;
      } else if (type == 3) {
        //支付宝小程序码
        var url1 =
          "https://www.58zltc.com/service/agent.index/aliapp_downLoad" + param;
        if (this.status == "test") {
          url1 =
            "https://cs.58zltc.com/service/agent.index/aliapp_downLoad" + param;
        }
        window.location.href = url1;
      }
    },
    downloadImg() {
      // var img = document.getElementById("testImg"); // 获取要下载的图片
      // var url = img.src; // 获取图片地址
      // var a = document.createElement("a"); // 创建一个a节点插入的document
      // var event = new MouseEvent("click"); // 模拟鼠标click点击事件
      // a.download = "图片名字"; // 设置a节点的download属性值
      // a.href =
      //   "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1595412779.jpg"; // 将图片的src赋值给a节点的href
      // // a.href = url; // 将图片的src赋值给a节点的href
      // a.dispatchEvent(event); // 触发鼠标点击事件
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    editors(id) {
      this.$router.push({
        path: `seting?idE=${id}`
      });
    },
    option(Oid) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: Oid
      };
      this.$confirm("确定要删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delWash(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.reload();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },
    //服务
    getLists() {
      console.log("presentId", this.presentId, this.$route.query);
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        id: this.presentId
      };
      indexWash(data).then(res => {
        if (res.code == 200) {
          this.listData = res.data.result;
          this.total_num = res.data.total_num;
          for (var i = 0; i < this.listData.length; i++) {
            this.listData[i].verify =
              this.listData[i].is_verify == 1 ? "是" : "否";
            this.listData[i].show = this.listData[i].status == 1 ? "是" : "否";
          }
        } else {
          this.$message.warning(res.msg);
        }
        console.log("列表", res);
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    }
  }
};
</script>
<style lang="scss" scoped>
.inner_content {
  height: 100%;
  background: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .header {
    padding-top: 20px;
    margin-bottom: 20px;
    .box {
      width: 330px;
      .title {
        min-width: 50px;
        text-align: right;
      }
      .fixedwidth {
        width: 180px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .bottom {
    flex: 1;
    overflow-y: scroll;
  }
  .page {
    height: 50px;
    display: flex;
    align-items: center;
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
